import type { SVGProps } from 'react'

export const BoxOpenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    viewBox="0 0 26 21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.698765 5.14742L2.39283 1.72672C2.5147 1.47652 2.78283 1.33297 3.05501 1.36988C6.37001 1.78824 9.68501 2.2066 13 2.62496C11.8706 4.52398 10.7413 6.42301 9.61189 8.32613C9.3072 8.83472 8.70595 9.07672 8.14126 8.91265C6.29283 8.37945 4.44845 7.84625 2.60001 7.31304C2.23439 7.2064 1.86876 7.10386 1.5072 6.99722C0.72314 6.77164 0.337202 5.8816 0.702827 5.14742H0.698765ZM13 2.62496L22.945 1.36988C23.2172 1.33707 23.4853 1.48062 23.6072 1.72672L25.3013 5.14742C25.6669 5.8816 25.2769 6.77164 24.4969 6.99722C24.1313 7.10386 23.7656 7.2064 23.4041 7.31304C21.5556 7.84625 19.7113 8.37945 17.8628 8.91265C17.2981 9.07672 16.6928 8.83472 16.3922 8.32613C15.2628 6.42711 14.1335 4.52808 13.0041 2.62496H13Z"
      fill="currentColor"
      opacity="0.4"
    />
    <path
      d="M13 4L10.068 8.69992C9.80781 9.11919 9.28398 9.31868 8.79531 9.18343L4 7.86475V14.634C4 15.3779 4.52734 16.0271 5.27969 16.2096L12.4551 17.9341C12.8137 18.022 13.1898 18.022 13.5449 17.9341L20.7203 16.2096C21.4727 16.0304 22 15.3812 22 14.634V7.86475L17.2047 9.18343C16.716 9.31868 16.1922 9.11919 15.932 8.69992L13 4Z"
      fill="currentColor"
    />
  </svg>
)
